(function() {
  let cachedCards = null;
  let paginationHTMLs = {};
  let totalPages = 1;
  let currentPage = 1;
  let pageSize = 24;
  let sectionId = '';
  let isLoading = false;

  async function initSorting() {
    if (isLoading) return;
    const gridEl = document.getElementById('product-grid');
    if (!gridEl) return;

    sectionId = gridEl.dataset.id;
    pageSize = parseInt(gridEl.dataset.pageSize || '24', 10);

    const pagWrapper = document.querySelector('.pagination-wrapper');
    const pageLinks = pagWrapper ? pagWrapper.querySelectorAll('nav.pagination a') : [];
    
    // Determine total pages
    totalPages = 1;
    if (pagWrapper) {
      pageLinks.forEach(link => {
        const url = new URL(link.href, window.location.origin);
        const p = parseInt(url.searchParams.get('page') || '1', 10);
        if (p > totalPages) totalPages = p;
      });
    }

    // Determine current page from URL
    const urlParams = new URLSearchParams(window.location.search);
    currentPage = parseInt(urlParams.get('page') || '1', 10);

    if (totalPages <= 1) {
      sortInPlace();
      return;
    }

    // Multi-page: Fetch all pages in parallel
    isLoading = true;
    const container = document.getElementById('ProductGridContainer')?.querySelector('.collection');
    if (container) container.classList.add('loading');

    paginationHTMLs = {};
    // Store current page pagination HTML
    paginationHTMLs[currentPage] = pagWrapper ? pagWrapper.outerHTML : '';

    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('page');
    searchParams.set('section_id', sectionId);

    const fetchPage = async (p) => {
      if (p === currentPage) {
        return Array.from(document.querySelectorAll('#product-grid li.grid__item'));
      }
      try {
        const params = new URLSearchParams(searchParams);
        params.set('page', p);
        const response = await fetch(`${window.location.pathname}?${params.toString()}`);
        if (!response.ok) throw new Error(`Failed to fetch page ${p}`);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        
        const cards = Array.from(doc.querySelectorAll('#product-grid li.grid__item'));
        const pWrapper = doc.querySelector('.pagination-wrapper');
        paginationHTMLs[p] = pWrapper ? pWrapper.outerHTML : '';
        return cards;
      } catch (err) {
        console.error('Error pre-fetching page:', p, err);
        return [];
      }
    };

    const promises = [];
    for (let p = 1; p <= totalPages; p++) {
      promises.push(fetchPage(p));
    }

    try {
      const allPagesCards = await Promise.all(promises);
      const flatCards = allPagesCards.flat();

      // Sort cards: available first, unavailable last
      flatCards.sort((a, b) => {
        const aAvail = a.getAttribute('data-available') === 'true' ? 1 : 0;
        const bAvail = b.getAttribute('data-available') === 'true' ? 1 : 0;
        return bAvail - aAvail; // available first
      });

      cachedCards = flatCards;
      
      // Render current page
      renderPage(currentPage);
    } catch (err) {
      console.error('Error sorting products:', err);
    } finally {
      isLoading = false;
      if (container) container.classList.remove('loading');
    }
  }

  function sortInPlace() {
    const grid = document.querySelector('#product-grid ul.grid') || document.querySelector('#product-grid.grid') || document.querySelector('#product-grid .grid');
    if (!grid) return;
    const cards = Array.from(document.querySelectorAll('#product-grid li.grid__item'));
    cards.sort((a, b) => {
      const aAvail = a.getAttribute('data-available') === 'true' ? 1 : 0;
      const bAvail = b.getAttribute('data-available') === 'true' ? 1 : 0;
      return bAvail - aAvail;
    });
    grid.innerHTML = '';
    cards.forEach((card, index) => {
      card.style.setProperty('--index', index);
      grid.appendChild(card);
    });
  }

  function renderPage(pageNumber) {
    if (!cachedCards) return;
    const grid = document.querySelector('#product-grid ul.grid') || document.querySelector('#product-grid.grid') || document.querySelector('#product-grid .grid');
    if (!grid) return;

    grid.innerHTML = '';
    const start = (pageNumber - 1) * pageSize;
    const end = start + pageSize;
    const slice = cachedCards.slice(start, end);
    slice.forEach((card, index) => {
      card.style.setProperty('--index', index);
      grid.appendChild(card);
    });

    // Update pagination wrapper HTML
    const pagWrapper = document.querySelector('.pagination-wrapper');
    if (pagWrapper && paginationHTMLs[pageNumber]) {
      pagWrapper.outerHTML = paginationHTMLs[pageNumber];
    }

    // Re-bind pagination clicks
    bindPaginationClicks();
  }

  function bindPaginationClicks() {
    const pagWrapper = document.querySelector('.pagination-wrapper');
    if (!pagWrapper) return;
    const links = pagWrapper.querySelectorAll('nav.pagination a');
    links.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const url = new URL(link.href, window.location.origin);
        const p = parseInt(url.searchParams.get('page') || '1', 10);
        
        currentPage = p;
        
        // Push state to browser history
        const newUrlParams = new URLSearchParams(window.location.search);
        newUrlParams.set('page', p);
        const newUrl = `${window.location.pathname}?${newUrlParams.toString()}`;
        
        history.pushState({ searchParams: newUrlParams.toString() }, '', newUrl);
        
        // Render
        renderPage(p);

        // Scroll to grid top
        const container = document.getElementById('ProductGridContainer');
        if (container) {
          container.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  // Bind to page load and custom events
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSorting);
  } else {
    initSorting();
  }

  document.dispatchEvent(new CustomEvent('grid-rendered')); // Run if already listener
  document.addEventListener('grid-rendered', initSorting);
})();
